// Billing client. Stub — no real Stripe yet. Server flips a flag
// (plan: 'pro', subscription.currentPeriodEnd = now + 30d) when
// subscribe() is called with a valid Bearer token. Cancel reverses it.
import { getToken } from './auth';

const API_BASE = (process.env.REACT_APP_API_BASE || '').replace(/\/$/, '');

async function authFetch(path, opts = {}) {
  const token = getToken();
  if (!token) {
    const err = new Error('Sign in required.');
    err.code = 'UNAUTHORIZED';
    err.status = 401;
    throw err;
  }
  const res = await fetch(`${API_BASE}${path}`, {
    ...opts,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...(opts.headers || {}),
    },
  });
  let data = null;
  try { data = await res.json(); } catch {}
  if (!res.ok) {
    const err = new Error(data?.error?.message || `HTTP ${res.status}`);
    err.status = res.status;
    err.code = data?.error?.code;
    throw err;
  }
  return data;
}

export async function subscribe() {
  return await authFetch('/api/billing/subscribe', { method: 'POST' });
}

export async function cancelSubscription() {
  return await authFetch('/api/billing/cancel', { method: 'POST' });
}
